module.exports = __webpack_public_path__ + "img/20200512_161544.d335273c.jpg";